import { render, staticRenderFns } from "./coderOutpatientReviewPage.vue?vue&type=template&id=34d275ab&scoped=true&"
import script from "./coderOutpatientReviewPage.vue?vue&type=script&lang=js&"
export * from "./coderOutpatientReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./coderOutpatientReviewPage.vue?vue&type=style&index=0&id=34d275ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d275ab",
  null
  
)

export default component.exports